import { stringify } from 'qs'

import RequestCore, { lsGetWithToken } from 'utils/request'
import { useCustomSWR } from 'utils/hooks/fetchers'

export const useArticleCount = (props, swrOptions) => {
  const genUrl = () => {
    try {
      const propsObject = typeof props === 'function' ? props() : props
      if (propsObject === null) {
        return null
      }
      return [
        `/articles/count?${stringify(propsObject)}`,
        RequestCore.getToken(),
      ]
    } catch (err) {
      return null
    }
  }
  return useCustomSWR(genUrl, lsGetWithToken, swrOptions)
}
